import React from "react";

import { GetStaticProps } from "next";
import {
  DTypeBeneficiaryHead,
  DTypeCardView,
  ATypeBreadCrumb,
  GOI_WEB_URL,
  ATypeBeneficiaryCTA,
} from "goi_common";
import crematorium from "goi_common/src/constants/hwajang_detail.json";
import facilities from "goi_common/src/constants/facilities_detail.json";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticProps: GetStaticProps = async () => {
  const regionCrematoriums = crematorium.filter((p) =>
    targetSidos.includes(String(p.sido))
  );
  const regionPublicFacilities = facilities.filter(
    (f) => targetSidos.includes(f.sido) && f.is_public
  );
  const description = "전라 광주 기초생활수급자 장례 혜택 4가지 안내";

  return {
    props: {
      regionCrematoriums,
      regionPublicFacilities,
      pageDescription: description,
      pageKeywords: `기초생활수급자 장례, 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마`,
      pageOgTitle: `기초생활수급자 장례 시 114, 요약 (광주전남전북) ::  전라광주장례추천포털`,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

export default function index({
  regionCrematoriums,
  regionPublicFacilities,
  pageOgTitle,
}: {
  regionCrematoriums: Array<any>;
  regionPublicFacilities: Array<any>;
  pageOgTitle: string;
}) {
  const carouselItems = regionCrematoriums.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.honam-funeralcenter.co.kr/free-benefit/free-crema/${res.companyname} 기초생활수급자 안내`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionCrematoriums.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
        {regionCrematoriums.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <ATypeBreadCrumb
        firstItem={{
          text: `기초수급자장례 추천`,
          href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
          event: {
            domain: "honam",
            path: "fr_benef",
            trigger_and_target: "br_crumb_mth_req",
          },
        }}
        secondItem={{
          text: `기초생활수급자 장례114`,
          href: `/free-benefit/`,
          event: {
            domain: "honam",
            path: "fr_benef",
            trigger_and_target: "br_crumb_fr_benef",
          },
        }}
        goiHomeEvent={{
          domain: "honam",
          path: "fr_benef",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />

      <DTypeBeneficiaryHead titleSido="전라 · 광주" />
      <Stack padding="20px 20px 0px">
        <ATypeBeneficiaryCTA
          mainColor={regionColor}
          event={{
            domain: "honam",
            path: "fr_benef",
            trigger_and_target: "goi_call",
          }}
        />
      </Stack>
      <Stack padding="20px">
        <Box width="100%" height="1px" style={{ background: "black" }} />
      </Stack>
      <Stack padding="24px 16px 10px" gap="12px">
        <h4 className="subtitle_18_b">전라 광주 기초생활수급자 무료 화장장</h4>
        {regionCrematoriums.map((res) => (
          <DTypeCardView
            address={res.address}
            descriptions={["기초생활수급자 무료"]}
            key={res.companyname}
            name={res.companyname}
            href={`/free-benefit/free-crema/기초생활수급자 화장장 ${res.companyname}/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "honam",
              path: "fr_benef",
              trigger_and_target: "uv_fr_crema_detail",
            }}
          />
        ))}
      </Stack>
      <Stack padding="20px">
        <Box width="100%" height="1px" style={{ background: "black" }} />
      </Stack>
      <Stack padding="24px 16px 10px" gap="12px">
        <h4 className="subtitle_18_b">
          전라 광주 기초생활수급자 무료 장지 (공설)
        </h4>
        {regionPublicFacilities.map((res) => (
          <DTypeCardView
            address={res.address}
            // descriptions={["기초생활수급자 무료"]}
            descriptions={[""]}
            key={res.companyname}
            name={res.companyname}
            href={`/free-benefit/free-facility/기초생활수급자 공설장지 ${res.companyname}/`}
            imgSrc={res.images[0] ? res.images[0].url : ""}
            event={{
              domain: "honam",
              path: "fr_benef",
              trigger_and_target: "uv_fr_facility_detail",
            }}
          />
        ))}
      </Stack>
    </>
  );
}
